var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOccupDropdown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 8,
    viewBox: "0 0 16 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.03448 7.99925C8.30764 7.99346 8.56871 7.896 8.76716 7.72573L15.6631 1.72392C15.8735 1.53925 15.9946 1.28647 15.9998 1.02099C16.005 0.755501 15.8939 0.49898 15.6909 0.307638C15.4878 0.116296 15.2093 0.00573676 14.9165 0.000218774C14.6237 -0.00529969 14.3404 0.0946682 14.1288 0.278195L8 5.61573L1.87124 0.278194C1.65958 0.0946671 1.3763 -0.00530085 1.08348 0.000217564C0.790661 0.0057355 0.512201 0.116294 0.309136 0.307636C0.10607 0.498979 -0.00503475 0.755499 0.000175149 1.02098C0.00538505 1.28647 0.126483 1.53925 0.336927 1.72392L7.23284 7.72573C7.33961 7.81746 7.46553 7.88892 7.6032 7.93589C7.74086 7.98287 7.8875 8.0044 8.03448 7.99925Z",
    fill: "#747474"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOccupDropdown);
export default __webpack_public_path__ + "static/media/occupDropdown.f0a87312fd6eb610537a405ed76c3218.svg";
export { ForwardRef as ReactComponent };